import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DataService } from '../../services/data/data.service';
import { LoginService } from '../../services/login/login.service';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Authenticate } from '../../models/authenticate';


@Component({
  selector: 'app-notice',
  templateUrl: './notice.html',
  styleUrls: ['./notice.css'],
  imports: [RouterModule, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule],
})
export class Notice {
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
